export default __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-2-26bd4137ecf25355339c0943f29175a6.jpg";